"use strict";
var Model = require("../types/Model.js");

module.exports = Model({
	name: "newsectionupdates",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_new: null,
	_existing: null,
	_who: null,

	recalculate: recalculate,
	view: view
});

function init() {
	this._new = {};
	this._existing = {};
	this.push({});
}

function listeners() {
	return {
		"sectionupdates:updated": updateSection("new"),
		"sectionupdateviews:updated": updateSection("existing"),

		"ownformsubmissions:viewing": viewGroupForm,
		"ownreminders:viewing": makeViewer("reminders"),
	};
}

function makeViewer(section) {
	return function(){
		this.view({
			section: section
		});
	};
}


function triggers() {
	return {
		"view": view
	};
}

function viewGroupForm(data) {
	var section = "groupforms_" + data.form;
	this.view({
		section: section
	});
}

function view(data) {
	var section = data.section;
	var newTimestamp = this._new[section];
	var existingTimestamp = this._existing[section];

	if(!newTimestamp) return;
	if(newTimestamp === existingTimestamp) return;

	this.emit("sectionupdateviews:trigger:update", {
		section: section,
		timestamp: newTimestamp
	});
}

function updateSection(section) {
	return function updater(data){
		this["_" + section] = data;
		this.recalculate();
	};
}

function recalculate() {
	var newUpdates = this._new;
	var existingUpdates = this._existing;

	var unseenUpdates = Object.keys(newUpdates).filter(function(section){
		if(!newUpdates[section]) return false;
		if(!existingUpdates[section]) return true;
		var newTimestamp = new Date(newUpdates[section]).getTime();
		var existingTimestamp = new Date(existingUpdates[section]).getTime() + 3000; // Add 3 seconds to account for the delay in the view event
		if(existingTimestamp >= newTimestamp) return false; // Should not show notification (viewed more recently than the most recent submission)
		return true; // Should show notification
	}).reduce(function(result, section){
		result[section] = newUpdates[section];
		return result;
	}, {});

	this.push(unseenUpdates);
}
